// @ts-nocheck
/* eslint-disable */
export const flFeedbackIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 2.5V19H6.99976L3 21.5V2.5H21Z" stroke="currentColor" stroke-width="1.5"/><path d="M7 8H17" stroke="currentColor" stroke-width="1.5"/><path d="M7 12.5H14" stroke="currentColor" stroke-width="1.5"/></svg>`,
    name: 'feedback' as const
};